/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Skeleton } from '@/components/ui/skeleton';

/**
 * Component that provides a loading state placeholder for category breadcrumbs.
 * @returns A skeleton layout matching the breadcrumbs navigation structure
 */
export function CategoryBreadcrumbsSkeleton() {
    return (
        <nav aria-label="Breadcrumb" className="mb-6 text-[12px] font-stjude-regular leading-5 text-[#333333] sm:text-[13px]" data-testid="breadcrumbs-skeleton">
            <div className="flex flex-wrap items-center">
                <Skeleton className="h-4 w-14 rounded-sm" />
                <Skeleton className="mx-1 h-3 w-3 rounded-sm" />
                <Skeleton className="h-4 w-20 rounded-sm" />
                <Skeleton className="mx-1 h-3 w-3 rounded-sm" />
                <Skeleton className="h-4 w-28 rounded-sm" />
            </div>
        </nav>
    );
}
